import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import styles from "./Sidebar.module.css";
import logo from "../../../assets/images/LightLogo.webp";

import {
  RiBarChartFill,
  RiHome2Line,
  RiAdvertisementFill,
} from "react-icons/ri";
import { BiCategory } from "react-icons/bi";
import { FaUsers } from "react-icons/fa";
import { RiArticleLine } from "react-icons/ri";
import { LogoutOutlined } from "@ant-design/icons";
import { CloseOutlined } from "@ant-design/icons";
import { Layout, Menu, MenuProps, Drawer, Button } from "antd";
import { MailOutlined, SettingOutlined, MenuOutlined } from "@ant-design/icons";
import { useDispatch } from "react-redux";
import { logoutReducer } from "../../../redux/slices/authSlice";
import { auth } from "../../../firebase";
import classes from "./Sidebar.module.css";
import { useIsMobile } from "../../../hooks/useIsMobile";
const { Sider } = Layout;
type MenuItem = Required<MenuProps>["items"][number];

const getMenuItems = (
  handleLogout: () => void,
  showLogout: boolean = true,
): MenuItem[] => {
  const items: MenuItem[] = [
    {
      key: "sub1",
      icon: (
        <div className={classes.customOption}>
          <img
            src="https://cdn.britannica.com/18/114418-050-E12B5707/Flag-Kosovo.jpg"
            alt="Kosova"
          />
          KOSOVE
        </div>
      ),
      children: [
        {
          key: "/posts",
          icon: <RiHome2Line />,
          label: <Link to={"posts"}>Posts </Link>,
        },
        {
          key: "/categories",
          icon: <BiCategory />,
          label: <Link to={"categories"}>Categories </Link>,
        },
        {
          key: "/sources",
          icon: <RiBarChartFill />,
          label: <Link to={"sources"}>Sources </Link>,
        },
      ],
    },
    {
      key: "sub4",
      label: (
        <div className={classes.customOption}>
          <img
            src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRC3oC2fAPycTMRBwivt_59S07mU48t--9m8Q&s"
            alt="Shqiperia"
          />
          ALBANIA
        </div>
      ),
      children: [
        {
          key: "/albanianposts",
          icon: <RiHome2Line />,
          label: <Link to={"albanianposts"}>Posts </Link>,
        },
        {
          key: "/albaniancategories",
          icon: <BiCategory />,
          label: <Link to={"albaniancategories"}>Categories </Link>,
        },
        {
          key: "/albaniansources",
          icon: <RiBarChartFill />,
          label: <Link to={"albaniansources"}>Sources </Link>,
        },
      ],
    },
    {
      key: "/adspanel",
      icon: <RiAdvertisementFill />,
      label: <Link to={"adspanel"}>ADVERTISMENT</Link>,
    },
    {
      key: "/users",
      icon: <FaUsers />,
      label: <Link to={"users"}>USERS</Link>,
    },
    {
      key: "/lajmet",
      icon: <RiArticleLine />,
      label: <Link to={"/lajmet"}>NEWS</Link>,
    },
  ];

  if (showLogout) {
    items.push({
      key: "logout",
      icon: <LogoutOutlined />,
      label: (
        <span onClick={handleLogout} style={{ cursor: "pointer" }}>
          Sign Out
        </span>
      ),
    });
  }

  return items;
};

const Sidebar: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [drawerOpen, setDrawerOpen] = useState(false);
  const isMobile = useIsMobile();

  const handleLogout = () => {
    dispatch(logoutReducer());
    auth.signOut();
    navigate("/login");
    setDrawerOpen(false);
  };

  const SidebarContent = () => (
    <>
      <Link to="/lajmet">
        <div
          style={{
            height: "2.2rem",
            width: "9rem",
            marginTop: "2.6rem",
            margin: 16,
            display: "flex",
            alignItems: "center",
            marginBottom: "3.5rem",
          }}
        >
          <img
            src={logo}
            alt="logo"
            style={{ width: "9rem", height: "auto" }}
          />
        </div>
      </Link>
      <div>
        <h2
          style={{
            fontSize: "1rem",
            color: " #757575",
            fontWeight: "500",
            paddingLeft: "2rem",
            marginBottom: "1.5rem",
          }}
        >
          Menu
        </h2>
      </div>

      <Menu
        className={styles.menuSider}
        theme="dark"
        mode="inline"
        defaultSelectedKeys={[location.pathname]}
        items={getMenuItems(handleLogout, false)}
      />
    </>
  );

  if (isMobile) {
    return (
      <>
        <div className={styles.mobileHeader}>
          <Button
            type="primary"
            icon={<MenuOutlined />}
            onClick={() => setDrawerOpen(true)}
            className={styles.burgerButton}
          />
          <Link to="/lajmet">
            <div
              style={{ display: "flex", alignItems: "center", gap: "0.5rem" }}
            >
              <img
                src={logo}
                alt="logo"
                style={{ width: "6.75rem", height: "auto" }}
              />
            </div>
          </Link>
        </div>
        <Drawer
          title={<span style={{ color: "white", fontWeight: 500 }}>Menu</span>}
          placement="left"
          onClose={() => setDrawerOpen(false)}
          open={drawerOpen}
          bodyStyle={{ padding: 0 }}
          drawerStyle={{
            backgroundColor: "#001529",
          }}
          closeIcon={
            <CloseOutlined style={{ color: "white", fontSize: "1.2rem" }} />
          }
          width={Math.min(window.innerWidth, 260)}
        >
          <Menu
            className={styles.menuSider}
            theme="dark"
            mode="inline"
            defaultSelectedKeys={[location.pathname]}
            items={getMenuItems(handleLogout, true)}
          />
        </Drawer>
      </>
    );
  }

  return (
    <Layout>
      <Sider
        style={{
          overflow: "auto",
          height: "100vh",
          width: "100rem",
          position: "fixed",
          left: 0,
          top: 0,
          bottom: 0,
          zIndex: 999,
        }}
      >
        <SidebarContent />
      </Sider>
    </Layout>
  );
};

export default Sidebar;
